import { useEffect, useRef, useState } from "react";
import { ChemistryPlayerPositions, FormationData, TeamChemistry } from "../../../types/IOption";
import IApiResponse from "../../../types/IApiResponse";
import { postData } from "../../../services/api";
import apiUrls from "../../../config/apiUrls";
import handleApiResponse from "../../../utils/handleApiResponse";
import { IPlayerCardData } from "../../../types/IPlayerDetail";
import Pitch from "../../Pitch";
import PlayerLandingCard from "../../../ui/CardComponent";
import { IPlayerCardDetail } from "../../../types/IPlayerCardDetail";
import { useLoading } from "../../../contexts/LoadingContext";
import {
  fetchOverallFormationData,
  fetchPlayerCardData,
  fetchPredictiveChemistryConnection,
} from "../../../pages/Chemistry/Utils";
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import Switch from "../../../ui/CustomSwitch";
import PositiveArrow from "../../../assets/icons/PositiveArrow.png";
import NegativeArrow from "../../../assets/icons/NegativeArrow.png";
import { BackToTeamChemistryBtn } from "../../../pages/Chemistry/StyledChemistryElements";
import Simulate from "../../../assets/icons/Simulate.png";
import { FormationSelectDrawer } from "../../../pages/Chemistry/UIContent";
import LabelText from "../../../ui/LabelText";
import CustomButton from "../../../ui/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface IPlayerSystemFit {
  playerId: number;
  seasonId: number;
  teamId: number;
  playerData: IPlayerCardData | undefined;
  timeframe: string;
}

interface IPlayerSystemFitView {
  positionResults: ChemistryPlayerPositions[];
  playerSystemFit: TeamChemistry[];
  teamSystemFit: TeamChemistry[];
}

export const PlayerSystemFit: React.FC<IPlayerSystemFit> = ({ playerId, seasonId, teamId, playerData, timeframe }) => {
  const [playerPositionResults, setPlayerPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [playerTeamChemistry, setPlayerTeamChemistry] = useState<TeamChemistry[]>([]);
  const [positionResults, setPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [teamChemistry, setTeamChemistry] = useState<TeamChemistry[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [swapHoverPlayer, setSwapHoverPlayer] = useState<number>(0);
  const [playerCardID, setPlayerCardID] = useState<number>(0);
  const [playerCardDetails, setPlayerCardDeatils] = useState<IPlayerCardDetail | undefined>(undefined);
  const playerCardRef = useRef(null);
  const { startLoading, stopLoading } = useLoading();
  const [sidebarPlayerShow, setSidebarPlayerShow] = useState<boolean>(false);
  const [swapPositionCode, setSwapPositionCode] = useState<string>("");
  const [teamView, setTeamView] = useState<boolean>(false);
  const [selectedTeam, setSelectedTeam] = useState<number>(
    playerData?.loanClubId! > 0 ? playerData?.loanClubId! : Number(playerData?.clubId)
  );
  const [formationData, setFormationData] = useState<FormationData[]>([]);
  const [selectedFormation, setSelectedFormation] = useState<number>(0);
  const [isSwapActive, setIsSwapActive] = useState<boolean>(false);
  const [overallSFScore, setOverallSFScore] = useState<number>(0);
  const [newOverallSFScore, setNewOverallSFScore] = useState<number>(0);
  const [avgAge, setAvgAge] = useState<number>(0);
  const [newAvgAge, setNewAvgAge] = useState<number>(0);
  const [attackContribution, setAttackContribution] = useState<number>(0);
  const [newAttackContribution, setNewAttackContribution] = useState<number>(0);
  const [ppda, setPPDA] = useState<number>(0);
  const [newPPDA, setNewPPDA] = useState<number>(0);
  const [sidebarFormationOpen, setSidebarFormationOpen] = useState<boolean>(false);

  useEffect(() => {
    setTeamView(false);
    setPositionResults([]);
    setTeamChemistry([]);
    setPlayerPositionResults([]);
    setPlayerTeamChemistry([]);
    setSelectedTeam(playerData?.loanClubId! > 0 ? playerData?.loanClubId! : Number(playerData?.clubId));
  }, [playerId, playerData]);

  const previousClubIdRef = useRef<number | null>(null);
  useEffect(() => {
    const fetchSystemFitData = async () => {
      setIsLoading(true);
      await fetchOverallFormationData(selectedTeam, setFormationData, setSelectedFormation);
      try {
        const ApiRequestData = {
          playerId: playerId,
          seasonId: seasonId,
          // teamId: playerData?.loanClubId! > 0 ? playerData?.loanClubId : playerData?.clubId,
          teamId : teamId
        };
        const response: IApiResponse<IPlayerSystemFitView> = await postData(apiUrls.PlayerTeamSystemFitView, ApiRequestData);
        handleApiResponse(
          response,
          async (candidatePlayerChemistry) => {
            setPlayerPositionResults(candidatePlayerChemistry?.positionResults);
            const adjustedPlayerSystemFit = candidatePlayerChemistry?.playerSystemFit.map((connection) => ({
              ...connection,
              score: connection.score === 100 ? 99 : connection.score,
            }));
            const adjustedTeamSystemFit = candidatePlayerChemistry?.teamSystemFit.map((connection) => ({
              ...connection,
              score: connection.score === 100 ? 99 : connection.score,
            }));
            setPlayerTeamChemistry(adjustedPlayerSystemFit);
            setTeamChemistry(adjustedTeamSystemFit);
            setIsLoading(false);
          },
          (error) => {
            console.error(error);
            setIsLoading(false);
          }
        );
      } catch (error) {
        console.error("Error fetching player card data:", error);
        setIsLoading(false);
      }
    };
    const currentClubId = playerData?.loanClubId! > 0 ? playerData?.loanClubId : Number(playerData?.clubId);
    if (
      // playerPositionResults.length === 0 &&
      // Number(playerData?.clubId!) > 0 &&
      seasonId > 0 && teamId > 0 && !isLoading
    ) {
      // previousClubIdRef.current = currentClubId!;
      fetchSystemFitData();
    }
  }, [teamId,
    // playerData?.clubId,
     playerId, seasonId, positionResults.length]);

  useEffect(() => {
    if (playerCardID > 0) {
      fetchPlayerCardData(startLoading, stopLoading, playerCardID, setPlayerCardDeatils);
    } else {
      setPlayerCardDeatils(undefined);
    }
  }, [playerCardID]);

  useEffect(() => {
    const dataSource = playerPositionResults;
    if (isSwapActive) {
      setNewAvgAge(
        Number(
          (dataSource?.reduce((acc, curr) => acc + curr.age, 0) / dataSource.filter((player) => player.age > 0)?.length).toFixed(
            2
          )
        )
      );
      setNewAttackContribution(
        Math.trunc(
          dataSource?.reduce((acc, curr) => acc + curr.contributionValue, 0) /
            dataSource?.filter((player) => player?.playerId > 0)?.length
        )
      );
      setNewPPDA(Number(dataSource?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    } else {
      setAvgAge(
        Number(
          (dataSource?.reduce((acc, curr) => acc + curr.age, 0) / dataSource.filter((player) => player.age > 0)?.length).toFixed(
            2
          )
        )
      );
      setAttackContribution(
        Math.trunc(
          dataSource?.reduce((acc, curr) => acc + curr.contributionValue, 0) /
            dataSource?.filter((player) => player?.playerId > 0)?.length
        )
      );
      setPPDA(Number(dataSource?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    }
  }, [positionResults, playerPositionResults, teamView, isSwapActive]);

  useEffect(() => {
    const dataSource = teamView ? teamChemistry : playerTeamChemistry;
    if (isSwapActive) {
      setNewOverallSFScore(
        Math.trunc(
          dataSource?.reduce((acc, curr) => acc + curr.score, 0) /
            dataSource?.filter((connection) => connection?.score > 0)?.length
        )
      );
    } else {
      setOverallSFScore(
        Math.trunc(
          dataSource?.reduce((acc, curr) => acc + curr.score, 0) /
            dataSource?.filter((connection) => connection?.score > 0)?.length
        )
      );
    }
  }, [teamChemistry, playerTeamChemistry, teamView, isSwapActive]);

  const getAllMissingChemistrys = async () => {
    const allMissingLinks = teamChemistry?.filter((connection) => connection.score === 0);
    startLoading();
    const promises = allMissingLinks.map(async (connection) => {
      return fetchPredictiveChemistryConnection(
        connection.player1,
        connection.player2,
        () => {},
        () => {},
        setTeamChemistry,
        teamChemistry
      );
    });
    await Promise.all(promises);
    stopLoading();
  };

  const getChemistrybetweenPlayers = async (player1: number, player2: number) => {
    await fetchPredictiveChemistryConnection(player1, player2, startLoading, stopLoading, setTeamChemistry, teamChemistry);
  };

  const handleFormationChange = async (formationId: number) => {
    const fetchSystemFitData = async () => {
      setIsLoading(true);
      try {
        const ApiRequestData = {
          playerId: playerId,
          seasonId: seasonId,
          teamId: playerData?.loanClubId! > 0 ? playerData?.loanClubId : playerData?.clubId,
          formationId: formationId,
        };
        const response: IApiResponse<IPlayerSystemFitView> = await postData(apiUrls.PlayerTeamSystemFitView, ApiRequestData);
        handleApiResponse(
          response,
          async (candidatePlayerChemistry) => {
            setPlayerPositionResults(candidatePlayerChemistry?.positionResults);
            const adjustedPlayerSystemFit = candidatePlayerChemistry?.playerSystemFit.map((connection) => ({
              ...connection,
              score: connection.score === 100 ? 99 : connection.score,
            }));
            const adjustedTeamSystemFit = candidatePlayerChemistry?.teamSystemFit.map((connection) => ({
              ...connection,
              score: connection.score === 100 ? 99 : connection.score,
            }));
            setPlayerTeamChemistry(adjustedPlayerSystemFit);
            setTeamChemistry(adjustedTeamSystemFit);
            setIsLoading(false);
          },
          (error) => {
            console.error(error);
            setIsLoading(false);
          }
        );
      } catch (error) {
        console.error("Error fetching player card data:", error);
        setIsLoading(false);
      }
    };
    if (formationId > 0) {
      fetchSystemFitData();
    }
  };

  return (
    <div className="player-systemfit-container">
      <div className="player-pitch-container">
        <div className="player-toggle-containers">
          {teamChemistry?.some((connection) => connection.score === 0) && teamView && (
            <BackToTeamChemistryBtn className="player-view-predict-btn" onClick={() => getAllMissingChemistrys()}>
              <img src={Simulate} alt="simulate icon" />
              Predict missing scores
            </BackToTeamChemistryBtn>
          )}
          <div className="player-team-view-switcher">
            <p>PLAYER VIEW</p>
            <Switch
              id="chemistry-predict"
              toggled={teamView}
              onChange={() => setTeamView(!teamView)}
              source="Filter"
              isByComparison={false}
            />
            <p>TEAM VIEW</p>
          </div>
        </div>
        <Pitch
          selectedTeam={playerData?.loanClubId! > 0 ? playerData?.loanClubId : Number(playerData?.clubId)}
          currentView={"systemFit"}
          positionResults={playerPositionResults}
          teamChemistry={teamView ? teamChemistry : playerTeamChemistry}
          setSwapHoverPlayer={setSwapHoverPlayer}
          playerCardID={playerCardID}
          setPlayerCardID={setPlayerCardID}
          setSidebarPlayerShow={setSidebarPlayerShow}
          setSwapPositionCode={setSwapPositionCode}
          isIndividualChemistry={true}
          getChemistrybetweenPlayers={getChemistrybetweenPlayers}
          formationName={formationData.find((form) => form.id === selectedFormation)?.formation}
          setIsReplacePlayer={() => {}}
        />
        {isLoading && <ModuleSpinner />}
        {playerCardID > 0 && playerCardDetails?.playerId! > 0 && (
          <div className="squad-pitch-player-card" ref={playerCardRef}>
            <PlayerLandingCard
              key={playerCardDetails?.playerId!}
              playerId={playerCardDetails?.playerId!}
              givenName={playerCardDetails?.givenName!}
              familyname={playerCardDetails?.familyname!}
              playerImageURL={playerCardDetails?.playerImageURL!}
              isInjured={playerCardDetails?.isInjured!}
              onLoan={playerCardDetails?.onLoan!}
              primaryPlayingPosition={playerCardDetails?.primaryPlayingPosition!}
              age={playerCardDetails?.age!}
              heightInCM={playerCardDetails?.heightInCM!}
              playerAttributesByPosition={playerCardDetails?.playerAttributesByPosition!}
              contributionValue={playerCardDetails?.contributionValue!}
              performanceValue={playerCardDetails?.performanceValue!}
              setPlayerCardDeatils={setPlayerCardDeatils}
              setPlayerCardID={setPlayerCardID}
              isPlayerInShortlist={playerCardDetails?.isPlayerInShortlist!}
              isEasternPlayer={playerCardDetails?.isEasternPlayer!}
              playerLabel={playerCardDetails?.playerLabel!}
              archetypeName={playerCardDetails?.archetypeName!}
              archetypeId={playerCardDetails?.archetypeId!}
            />
          </div>
        )}
      </div>
      <div className="player-info-container">
        <div className="player-info-left-container">
          <div>
            <p>TIMEFRAME:</p>
            <p>{timeframe ? timeframe : "--"}</p>
          </div>
          <div>
            <LabelText className="team-selection-text">FORMATION:</LabelText>
            <CustomButton
              endIcon={<KeyboardArrowDownIcon />}
              color="primary"
              onClick={() => {
                setSidebarFormationOpen(!sidebarFormationOpen);
              }}
              style={{ padding: "0" }}
            >
              <LabelText className="player-given-name">
                {formationData.find((form) => form.id === selectedFormation)?.formation}
              </LabelText>
            </CustomButton>
          </div>
        </div>
        <div className="squad-summarybar-container">
          <div className="squad-chemistry-box">
            OVERALL SYSTEM FIT SCORE
            <span>
              {isLoading || (!newOverallSFScore && !overallSFScore) ? "--" : isSwapActive ? newOverallSFScore : overallSFScore}{" "}
              {isSwapActive && !isLoading && newOverallSFScore !== overallSFScore && (
                <span className={newOverallSFScore - overallSFScore > 0 ? "positive-difference" : "negative-difference"}>
                  <img src={newOverallSFScore - overallSFScore > 0 ? PositiveArrow : NegativeArrow} alt="" />
                  {newOverallSFScore - overallSFScore > 0
                    ? newOverallSFScore - overallSFScore
                    : overallSFScore - newOverallSFScore}
                </span>
              )}
            </span>
          </div>
          <div className="squad-chemistry-box">
            OVERALL ATTACK CONTRIBUTION
            <span>
              {isLoading || (!newAttackContribution && !attackContribution)
                ? "--"
                : isSwapActive
                ? newAttackContribution
                : attackContribution}{" "}
              {isSwapActive && !isLoading && newAttackContribution !== attackContribution && (
                <span className={newAttackContribution - attackContribution > 0 ? "positive-difference" : "negative-difference"}>
                  <img src={newAttackContribution - attackContribution > 0 ? PositiveArrow : NegativeArrow} alt="" />
                  {newAttackContribution - attackContribution > 0
                    ? newAttackContribution - attackContribution
                    : attackContribution - newAttackContribution}
                </span>
              )}
            </span>
          </div>
          <div className="squad-chemistry-box">
            PPDA
            <span>
              {isLoading || (!newPPDA && !ppda) ? "--" : isSwapActive ? newPPDA : ppda}{" "}
              {isSwapActive && !isLoading && newPPDA !== ppda && (
                <span className={newPPDA - ppda > 0 ? "negative-difference" : "positive-difference"}>
                  <img src={newPPDA - ppda > 0 ? NegativeArrow : PositiveArrow} alt="" className="inverted-arrow" />
                  {newPPDA - ppda > 0 ? (newPPDA - ppda).toFixed(2) : (ppda - newPPDA).toFixed(2)}
                </span>
              )}
            </span>
          </div>
          <div className="squad-chemistry-box">
            AV. AGE
            <span>
              {isLoading || (!newAvgAge && !avgAge) ? "--" : isSwapActive ? newAvgAge : avgAge}{" "}
              {isSwapActive && !isLoading && newAvgAge !== avgAge && (
                <span className={newAvgAge - avgAge > 0 ? "negative-difference" : "positive-difference"}>
                  <img src={newAvgAge - avgAge > 0 ? NegativeArrow : PositiveArrow} alt="" className="inverted-arrow" />
                  {newAvgAge - avgAge > 0 ? (newAvgAge - avgAge).toFixed(2) : (avgAge - newAvgAge).toFixed(2)}
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
      <FormationSelectDrawer
        sidebarFormationOpen={sidebarFormationOpen}
        setSidebarFormationOpen={setSidebarFormationOpen}
        formationData={formationData}
        selectedFormation={selectedFormation}
        setSelectedFormation={setSelectedFormation}
        handleFormationChange={handleFormationChange}
      />
    </div>
  );
};
